import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import BannerPage from '../BannerPage';

const Layout = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <BannerPage />
            <Navbar />
            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
